<template lang="pug">
div
  h4.mr-3 Configuración de Shopify
  p Para configurar la integración con Shopify, debes:
  ul
    li Agregar dos webhooks a tu tienda Shopify, en la sección de "Configuración" > "Notificaciones" > "Webhooks".
    li En el primer webhook, asegúrate de seleccionar la versión 2025-07 y el evento "Cancelación de pedido" y coloca cualquier URL, ya que la URL correcta será mostrada más abajo.
    li En el segundo webhook, asegúrate de seleccionar la versión 2025-07 y el evento "Proceso de envío de pedido" y coloca la misma URL.
    li Una vez creados los webhooks, cuando un pedido esté en estado "Preparado", se creará automáticamente un envío en la plataforma.
    li Cuando un pedido sea cancelado, se cancelará automáticamente el envío correspondiente en la plataforma.
  div(style="display: flex; align-items: center; gap: 10px; flex-direction: column; max-width: 100%;")
    h5.text-center Webhook URL
    div(v-if="webhookToken" style="display: flex; align-items: center; gap: 10px; justify-content: center")
      b-card(
        no-body
        style="border-radius: 5px; border: 1px solid #ccc; text-wrap: wrap; max-width: 100%; min-height: 40px; display: flex; align-items: center; justify-content: center;"
      )
        code.p-2(style="white-space: pre-wrap; word-wrap: break-word; word-break: break-all; overflow-wrap: break-word;") {{ webhookUrl }}
      b-button.url-action-btn(@click="copyToClipboard")
        .material-icons-outlined content_copy
      b-button.url-action-btn(@click="regenerateToken")
        .material-icons-outlined refresh
    b-button(v-else-if="!loading" @click="generateToken") Regenerar URL
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import settings from '../../../settings'

export default {
  data () {
    return {
      loading: false,
      webhookToken: ''
    }
  },
  computed: {
    ...mapGetters(['user']),
    storeId () {
      // For store users, use their store ID. For admin, this would need to be selected
      return this.user.role === 'store' ? this.user.storeId : null
    },
    webhookUrl () {
      return `${settings.baseApi}/integrations/shopify/webhook/${this.webhookToken}`
    }
  },
  methods: {
    ...mapActions(['regenerateShopifyToken', 'getStoreShopifyToken']),
    async fetchToken () {
      this.loading = true
      if (!this.storeId) {
        this.$bvToast.toast('Error: No se pudo determinar la tienda', {
          title: 'Error',
          variant: 'danger'
        })
        this.loading = false
        return
      }
      try {
        const response = await this.getStoreShopifyToken(this.storeId)
        this.webhookToken = response.data.token
      } catch (error) {
        /* eslint-disable */console.error(...oo_tx(`1575269622_65_8_65_53_11`,'Error fetching token:', error))
        this.$bvToast.toast('Error al obtener el token', {
          title: 'Error',
          variant: 'danger'
        })
      } finally {
        this.loading = false
      }
    },
    async generateToken () {
      this.loading = true
      if (!this.storeId) {
        this.$bvToast.toast('Error: No se pudo determinar la tienda', {
          title: 'Error',
          variant: 'danger'
        })
        this.loading = false
        return
      }

      try {
        const response = await this.regenerateShopifyToken(this.storeId)
        this.webhookToken = response.data.token

        this.$bvToast.toast('Token generado exitosamente', {
          title: 'Éxito',
          variant: 'success'
        })
      } catch (error) {
        /* eslint-disable */console.error(...oo_tx(`1575269622_94_8_94_55_11`,'Error generating token:', error))
        this.$bvToast.toast('Error al generar el token', {
          title: 'Error',
          variant: 'danger'
        })
      } finally {
        this.loading = false
      }
    },

    async regenerateToken () {
      const ok = await this.$bvModal.msgBoxConfirm('¿Está seguro de que desea regenerar el token? Esto invalidará el token actual y deberá actualizar la configuración en Shopify.', {
        title: 'Confirmación',
        okTitle: 'Regenerar',
        cancelTitle: 'Cancelar'
      })
      if (!ok) {
        return
      }
      await this.generateToken()
    },

    async loadRecentEvents () {
      this.eventsLoading = true
      try {
        // This would need to be implemented in the backend to track webhook events
        // For now, we'll show mock data
        this.recentEvents = [
          {
            timestamp: new Date(),
            event: 'orders/create',
            status: 'success',
            orderId: '#1001'
          },
          {
            timestamp: new Date(Date.now() - 3600000),
            event: 'orders/paid',
            status: 'success',
            orderId: '#1000'
          }
        ]
      } catch (error) {
        /* eslint-disable */console.error(...oo_tx(`1575269622_136_8_136_60_11`,'Error loading recent events:', error))
      } finally {
        this.eventsLoading = false
      }
    },

    async copyToClipboard () {
      this.copyLoading = true
      try {
        await navigator.clipboard.writeText(this.webhookUrl)
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 3000)
      } catch (error) {
        /* eslint-disable */console.error(...oo_tx(`1575269622_151_8_151_59_11`,'Error copying to clipboard:', error))
        // Fallback for older browsers
        const textArea = document.createElement('textarea')
        textArea.value = this.webhookUrl
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 3000)
      } finally {
        this.copyLoading = false
      }
      this.$bvToast.toast('URL copiada al portapapeles', {
        title: 'Éxito',
        variant: 'success'
      })
    },

    formatDate (date) {
      return new Date(date).toLocaleString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  },
  mounted () {
    this.fetchToken()
  }
}
</script>

<style lang="scss" scoped>
.shopify-integration {
  padding: 20px 0;
}

.display-4 {
  font-size: 3rem;
}

.input-group {
  .form-control[readonly] {
    background-color: #f8f9fa;
  }
}

.material-icons-outlined {
  font-family: 'Material Icons Outlined';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
}

.url-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 40px;
  width: 40px;
}
</style>
